import { createFileRoute } from '@tanstack/react-router'
import { convexQuery } from '@convex-dev/react-query'
import { api } from 'convex/_generated/api'
import type { Id } from 'convex/_generated/dataModel'
import UpdatePlanForm from '@/features/plans/components/UpdatePlanForm'

export const Route = createFileRoute('/_authed/plans/$planId/edit')({
  loader: async ({ context, params }) => {
    const planId = params.planId as Id<'plans'>
    await context.queryClient.ensureQueryData(convexQuery(api.plans.getPlan, { planId }))
  },
  component: PlanEditRouteWrapper,
})

function PlanEditRouteWrapper() {
  const { planId } = Route.useParams()
  return <UpdatePlanForm planId={planId as Id<'plans'>} />
}
